import { TabContext, TabPanel } from "@mui/lab";
import { Box, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import DriverPaymentEditor from "../../../components/accounting/DriverPaymentEditor";
import DriverDetails from "../../../components/asset-management/DriverDetails";
import HeaderTitle from "../../../components/common/HeaderTitle";
import { Driver, RateTableEntityType } from "../../../graphql/generated";
import { useNavigationOptions } from "../../LayoutRoutes";
import driverLabel from "../../../utils/labels/driverLabel";
import { useTranslation } from "react-i18next";
import RatingTableEditorContainer from "../../../components/accounting/RatingTableEditor";
import { testIds } from "./ViewDriver.testIds";

function ViewDriver() {
  const { t } = useTranslation(["common", "users"]);
  const { id } = useParams();
  const { setNavigationOptions } = useNavigationOptions();
  const onLoad = useCallback(
    (driver: Pick<Driver, "firstname" | "lastname">) => {
      setNavigationOptions({
        title: (
          <HeaderTitle
            label={t("users:driver.one", "Driver")}
            suffix={`${driverLabel(driver)}`}
          />
        ),
        showBackIcon: true,
      });
    },
    [setNavigationOptions, t]
  );
  const [activeTab, setActiveTab] = useState("DETAILS");
  if (!id) {
    return null;
  }
  return (
    <TabContext value={activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs data-testid={testIds.viewDriverDetails}
          value={activeTab}
          onChange={(event, value) => setActiveTab(value)}
          aria-label="Driver tabs"
        >
          <Tab data-testid={testIds.viewDriverOverview} label={t("details")} value="DETAILS" aria-label="Details" />
          <Tab data-testid={testIds.viewDriverPayment} label={t("payment")} value="PAYMENT" aria-label="Payment" />
          <Tab data-testid={testIds.viewDriverRating} label={t("rating", "Rating")} value="RATING" />
        </Tabs>
      </Box>

      <TabPanel value="DETAILS">
        <DriverDetails onLoad={onLoad} driverId={id} />
      </TabPanel>

      <TabPanel value="PAYMENT">
        <DriverPaymentEditor driverId={id} />
      </TabPanel>

      <TabPanel value="RATING">
        <RatingTableEditorContainer
          entityType={RateTableEntityType.Driver}
          entityId={id}
        />
      </TabPanel>
    </TabContext>
  );
}

export default ViewDriver;
